import { render, staticRenderFns } from "./addResourceStoreType.vue?vue&type=template&id=76e6fa60&scoped=true"
import script from "./addResourceStoreType.vue?vue&type=script&lang=js"
export * from "./addResourceStoreType.vue?vue&type=script&lang=js"
import style0 from "./addResourceStoreType.vue?vue&type=style&index=0&id=76e6fa60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e6fa60",
  null
  
)

export default component.exports